import { ProductPageTab } from './types';

export function getProductPageTabFromHash(
  hash: string | undefined
): ProductPageTab {
  const hashContent = hash && hash.substr(1);

  if (
    hashContent === 'properties' ||
    hashContent === 'reviews' ||
    hashContent === 'statistics'
  ) {
    return hashContent;
  }

  return 'main';
}
